/**
 *
 * Basic BetLine win presentation. Plays symbol "win" state animations one bet line win after another.
 * It resets the symbols to normal on abort.
 *
 * For use in "idleLoop" gameRound state, usually when there is no ZeroBet.
 *
 * Created by Jonas Wålekvist on 2019-08-12.
 */
import {Timeline, TimelineLite} from "gsap";
import {GameConfig} from "@nolimitcity/slot-game/bin/core/gameconfig/GameConfig";
import {ISymbolStateConfig, StateReelSymbol} from "@nolimitcity/slot-game/bin/core/reelsymbol/StateReelSymbol";
import {SpacierArcadeParsedGameData} from "../server/data/SpacierArcadeParsedGameData";
import {IBetWayWinData} from "@nolimitcity/slot-game/bin/core/server/data/IServerData";
import {SpacierArcadeGameConfig} from "../SpacierArcadeGameConfig";
import {SpacierArcadeModeData} from "../server/data/SpacierArcadeModeData";
import {SpacierArcadeGameMode} from "../gamemode/SpacierArcadeGameMode";
import {SpacierArcadeGameModuleConfig} from "../SpacierArcadeGameModuleConfig";
import {GameRoundPresentation} from "@nolimitcity/slot-game/bin/timelinegameround/core/gameround/GameRoundPresentation";
import {Reels} from "@nolimitcity/slot-game/bin/core/reel/reelarea/Reels";
import {EventHandler} from "@nolimitcity/slot-game/bin/core/event/EventHandler";
import {GameEvent} from "@nolimitcity/slot-game/bin/core/event/GameEvent";
import {SAReelEvent} from "../reel/SAReelController";
import {SAFreespinEvent} from "../background/SABackground";


export class Idle implements GameRoundPresentation {
    public stagger?:number;

    constructor(stagger?:number) {
        this.stagger = stagger;
    }

    public abort(isActive:boolean, data:SpacierArcadeParsedGameData):Timeline | null {
        return this.getAnimation(data);
    }

    public getAnimation(data:SpacierArcadeParsedGameData):Timeline | null {
        const tl: TimelineLite = new TimelineLite();
        tl.add(() => EventHandler.dispatchEvent(new GameEvent(SAFreespinEvent.UPDATE_BACK_IMAGE, true)));
        if(data !== null && data.singleWin  > 0) {
            const pauseDuration:number = data.currentTotalWinRatioConfig!.ratio <= 1.5 ? 0.4 : 1.2;
            tl.to({}, pauseDuration, {});
        }
        return tl;
    }


}